(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68998e8de3c6772fdf051fe4";
              window.beaePageSetting.pageTitle = "Warranty Policy"; 
              window.beaePageSetting.pageType = "section";

          let js_31N8AAO1 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-u4mw17xssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u4mw17xs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u4mw17xs');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u4mw17xs: ', ex)
      };
    

      try {
        let argid = 'beae-g3wvvupablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g3wvvupa',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g3wvvupa');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g3wvvupa: ', ex)
      };
    

      try {
        let argid = 'beae-a4zlhz86section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a4zlhz86',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a4zlhz86');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a4zlhz86: ', ex)
      };
    

      try {
        let argid = 'beae-6jhpua9sblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6jhpua9s',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6jhpua9s');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6jhpua9s: ', ex)
      };
    

      try {
        let argid = 'beae-a28fihxqblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a28fihxq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a28fihxq');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a28fihxq: ', ex)
      };
    

      try {
        let argid = 'beae-3p6skq7ublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3p6skq7u',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3p6skq7u');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3p6skq7u: ', ex)
      };
    

      try {
        let argid = 'beae-9zq91pc4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9zq91pc4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9zq91pc4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9zq91pc4: ', ex)
      };
    

      try {
        let argid = 'beae-468xvffbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-468xvffb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-468xvffb');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-468xvffb: ', ex)
      };
    

      try {
        let argid = 'beae-cjbvivovsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cjbvivov',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cjbvivov');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cjbvivov: ', ex)
      };
    

      try {
        let argid = 'beae-x2oslmnvblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x2oslmnv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x2oslmnv');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x2oslmnv: ', ex)
      };
    

      try {
        let argid = 'beae-ozpu58xwblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ozpu58xw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ozpu58xw');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ozpu58xw: ', ex)
      };
    

      try {
        let argid = 'beae-zobcg7yrblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zobcg7yr',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zobcg7yr');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zobcg7yr: ', ex)
      };
    

      try {
        let argid = 'beae-vennmmv3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vennmmv3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vennmmv3');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vennmmv3: ', ex)
      };
    

      try {
        let argid = 'beae-xnx99i5osection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xnx99i5o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xnx99i5o');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xnx99i5o: ', ex)
      };
    

      try {
        let argid = 'beae-y20n21gbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y20n21gb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y20n21gb');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y20n21gb: ', ex)
      };
    

      try {
        let argid = 'beae-777cx7wiblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-777cx7wi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-777cx7wi');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-777cx7wi: ', ex)
      };
    

      try {
        let argid = 'beae-6349oap4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6349oap4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6349oap4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6349oap4: ', ex)
      };
    

      try {
        let argid = 'beae-tjm0o3l4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tjm0o3l4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tjm0o3l4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tjm0o3l4: ', ex)
      };
    

      try {
        let argid = 'beae-wytqfk66section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wytqfk66',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wytqfk66');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wytqfk66: ', ex)
      };
    

      try {
        let argid = 'beae-79ifo2xcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-79ifo2xc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-79ifo2xc');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-79ifo2xc: ', ex)
      };
    

      try {
        let argid = 'beae-6hd23u51block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6hd23u51',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6hd23u51');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6hd23u51: ', ex)
      };
    

      try {
        let argid = 'beae-5j6ut3lyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5j6ut3ly',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5j6ut3ly');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5j6ut3ly: ', ex)
      };
    

      try {
        let argid = 'beae-ldbuh2hmblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ldbuh2hm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ldbuh2hm');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ldbuh2hm: ', ex)
      };
    

      try {
        let argid = 'beae-e3nl0q7gblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e3nl0q7g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e3nl0q7g');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e3nl0q7g: ', ex)
      };
    }; if (window.BEAEBASE) {js_31N8AAO1()} else {window.BEAEPAGEJS.push(js_31N8AAO1)} })(); 